import {
  useCreateSiteMutation,
  useDeleteSiteMutation,
  useGetAllSitesMutation,
  useLazySiteDetailsQuery,
  useUpdateSiteMutation,
} from "../store/services/sitesQuery";

export const useSites = () => {
  const [
    createSite,
    {
      data: createSiteData,
      isLoading: createSiteIsLoading,
      isError: createSiteIsError,
      error: createSiteError,
      isSuccess: createSiteIsSuccess,
    },
  ] = useCreateSiteMutation();
  const [
    getAllSites,
    {
      data: allSitesData,
      isLoading: allSitesIsLoading,
      isError: allSitesIsError,
      error: allSitesError,
      isSuccess: allSitesIsSuccess,
    },
  ] = useGetAllSitesMutation();
  const [
    updateSite,
    {
      data: updateSiteData,
      isLoading: updateSiteIsLoading,
      isError: updateSiteIsError,
      error: updateSiteError,
      isSuccess: updateSiteIsSuccess,
    },
  ] = useUpdateSiteMutation();
  const [
    deleteSite,
    {
      data: deleteSiteData,
      isLoading: deleteSiteIsLoading,
      isError: deleteSiteIsError,
      error: deleteSiteError,
      isSuccess: deleteSiteIsSuccess,
    },
  ] = useDeleteSiteMutation();
  const [
    getSiteDetails,
    {
      data: siteDetailsData,
      isLoading: siteDetailsIsLoading,
      isError: siteDetailsIsError,
      error: siteDetailsError,
      isSuccess: siteDetailsIsSuccess,
    },
  ] = useLazySiteDetailsQuery();

  return {
    createSite,
    createSiteData,
    createSiteIsLoading,
    createSiteIsError,
    createSiteError,
    createSiteIsSuccess,
    getAllSites,
    allSitesData,
    allSitesIsLoading,
    allSitesIsError,
    allSitesError,
    allSitesIsSuccess,
    updateSite,
    updateSiteData,
    updateSiteIsLoading,
    updateSiteIsError,
    updateSiteError,
    updateSiteIsSuccess,
    deleteSite,
    deleteSiteData,
    deleteSiteIsLoading,
    deleteSiteIsError,
    deleteSiteError,
    deleteSiteIsSuccess,
    getSiteDetails,
    siteDetailsData,
    siteDetailsIsLoading,
    siteDetailsIsError,
    siteDetailsError,
    siteDetailsIsSuccess,
  };
};
